// src/pages/Contact.tsx
import React from 'react';
import { Link } from 'react-router-dom';



const GetInTouch: React.FC = () => {




  return (


<>

  {/* ==== Let's Talk start ==== */}
  <div className="talkk pb--50 pb_sm--20 pt_sm--10">
    <div className="container">
      <div className="row">
        <div className="col-12">
          <div className="talkk__content">
            <div className="intro text-center">
              <h2 className="light-title text-uppercase title-anim">
                Let's make some magic ✨ happen and show the world what your
                brand is all about!
              </h2>
            </div>
            <div className="row justify-content-center cta-t section__content-cta">
              <div className="col-12 col-md-8">
                <h3>
                  <Link to="/contact" className="">
                    Let's Talk
                    <i className="fa-regular fa-comment-dots" />
                  </Link>
                </h3>
                <p>Let's make your brand the talk of the town</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* ==== / Let's Talk end ==== */}


</>



  );
};

export default GetInTouch;
